import { useTranslation } from 'react-i18next';
import { EmployeePhoto } from './EmployeePhoto';
import { usePeoplePickerStyles } from './PeoplePicker.styles';

interface SearchResultCardProps {
  displayName: string;
  userPrincipalName: string;
  jobTitle: string | null;
  officeLocation: string | null;
  isActive: boolean;
  onClick: () => void;
}

export function SearchResultCard({
  displayName,
  userPrincipalName,
  jobTitle,
  officeLocation,
  isActive,
  onClick,
}: SearchResultCardProps) {
  const { t } = useTranslation('bookingForm');
  const styles = usePeoplePickerStyles();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`${styles.resultItem} ${isActive ? styles.resultItemActive : ''}`}
      role="option"
      aria-selected={isActive}
      tabIndex={isActive ? 0 : -1}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      onMouseDown={(e) => e.preventDefault()}
    >
      <EmployeePhoto employeeId={userPrincipalName} displayName={displayName} />
      <div className={styles.resultInfo}>
        <span className={styles.resultName}>{displayName}</span>
        <span className={styles.resultDetail}>
          {jobTitle || t('bookingForm.peoplePicker.noJobTitle')}
        </span>
        <span className={styles.resultDetail}>
          {officeLocation || t('bookingForm.peoplePicker.noLocation')}
        </span>
      </div>
    </div>
  );
}
